// src/components/InstallPrompt.jsx
import { useEffect, useState } from 'react'

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onBIP = (e) => {
      e.preventDefault() // 기본 설치 배너 막기
      setDeferredPrompt(e)
      setVisible(true)
    }
    window.addEventListener('beforeinstallprompt', onBIP)
    return () => window.removeEventListener('beforeinstallprompt', onBIP)
  }, [])

  if (!visible) return null

  const handleInstall = async () => {
    if (!deferredPrompt) return
    deferredPrompt.prompt()
    const { outcome } = await deferredPrompt.userChoice
    console.log('PWA install choice:', outcome)
    setDeferredPrompt(null)
    setVisible(false)
  }

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50">
      <div className="flex items-center gap-3 rounded-xl border bg-white px-4 py-3 shadow-xl">
        <span className="text-sm">Floater를 설치해서 앱처럼 사용해보세요!</span>
        <button
          onClick={handleInstall}
          className="px-3 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700"
        >
          설치
        </button>
      </div>
    </div>
  )
}
